var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center",attrs:{"wrap":""}},[_c('circles-loader'),(_vm.error)?_c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t('message.error_generic')))]),_c('v-btn',{on:{"click":function($event){return _vm.goBack()}}},[_vm._v(" "+_vm._s(_vm.$t('message.back'))+" ")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }